import { render, staticRenderFns } from "./modalInstrucoes.vue?vue&type=template&id=99cf0ba8&scoped=true&"
import script from "./modalInstrucoes.vue?vue&type=script&lang=js&"
export * from "./modalInstrucoes.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=99cf0ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cf0ba8",
  null
  
)

export default component.exports